import React from "react";
import Modal, { ModalProps } from "@/app/pwa/components/Modal";
import { ClubProfile } from "@/app/pwa/components/UserDisplay/ClubProfile";
import { SessionUser } from "@/app/pwa/components/UserDisplay/UserModalDisplay";
import { signOut } from "next-auth/react";
import { SessionUserImage } from "../UserImage";
import {useUserPersons} from "@/app/pwa/lib/pwa-context";

interface UserModalProps extends ModalProps {
  user: SessionUser;
}
export function UserModal({ user, onRequestClose, ...attributes }: UserModalProps) {
  const persons = useUserPersons();

  return (
    <Modal {...attributes} onRequestClose={onRequestClose} className="w-full max-w-md" >
        <div>
          <div className="flex flex-col items-center pb-4">
            <div className="rounded-full overflow-hidden">
              <SessionUserImage user={user} className="w-16 h-16" />
            </div>
            <div className="uppercase text-lg font-semibold pt-2">
              {user.name}
            </div>
            <div className="text-gray-200 font-compressed">kicker-account</div>
          </div>
          {persons.length > 0 &&
            <ClubProfile persons={persons} onRequestClose={onRequestClose}/>
          }
          <div className="border-t border-gray-150 pt-6">
            <button
              className="button button--link-muted w-full justify-center"
              onClick={() => signOut()}
            >
              Abmelden
            </button>
          </div>
        </div>
    </Modal>
  );
}
